<template>
    <div class="dashboard">
        <Breadcumb :title="$t('create_survey')" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <form-wizard ref="formWizard" class="form-wizard-boxed-steps cardcontainer">
            <!-- Allow html in tab title (this template required for the proper styling) -->
            <template slot="step" slot-scope="props">
                <wizard-step :tab="props.tab" @click.native="props.navigateToTab(props.index)"
                             @keyup.enter.native="props.navigateToTab(props.index)" :transition="props.transition"
                             :index="props.index">
                    <span slot="title" :class="{'text-danger':props.tab.validationError}"
                          v-html="props.tab.title"></span>
                </wizard-step>
            </template>
            <tab-content :title="'<div class=\'small text-muted\'>'+ $t('step_1') + '</div>' + $t('survey_configuration')"
                         :before-change="() => validateStep(1)">
                <b-card no-body class="mb-3">
                    <b-card-body>
                        <b-alert v-if="error" show variant="danger">
                            {{ error }}
                        </b-alert>
                        <b-alert  show variant="warning">
                            {{ $t('survey_label_disc') }}
                        </b-alert>
                        <b-form-group :label="$t('survey_language')" label-align-md="right" label-class="pr-md-2"
                                      :label-cols-md="2">
                            <b-check-group v-model="languages" :options="languageData"/>
                        </b-form-group>
                        <b-form-group :label="$t('survey_type')" label-align-md="right" label-class="pr-md-2"
                                      :label-cols-md="2">
                            <b-select value="group" v-model="surveyType" :options="surveyTypes"
                                      @change="typeChange($event)"/>
                        </b-form-group>
                        <b-form-group :label="$t('survey_name')" label-align-md="right" label-class="pr-md-2"
                                      :label-cols-md="2">
                            <b-input value="1" v-model="label"/>
                        </b-form-group>
                        <b-form-group :label="$t('survey_begin_date')" label-align-md="right" label-class="pr-md-2"
                                      :label-cols-md="2">
                            <datepicker style="min-width:250px" v-model="date" :bootstrapStyling="true"
                                        :placeholder="$t('survey_begin_date')"/>
                        </b-form-group>
                        <b-form-group :label="$t('survey_end_date')" label-align-md="right" label-class="pr-md-2"
                                      :label-cols-md="2">
                            <datepicker style="min-width:250px" v-model="dateend" :bootstrapStyling="true"
                                        :placeholder="$t('survey_end_date')"/>
                        </b-form-group>
                        <b-form-group :label="$t('companies')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                            <v-jstree
                                    :data="treeData"
                                    :class="{ 'tree-rtl': isRTL }"
                                    show-checkbox
                                    multiple
                                    allow-batch
                                    whole-row
                                    draggable/>
                        </b-form-group>
                    </b-card-body>
                </b-card>
            </tab-content>
            <tab-content  :title="'<div class=\'small text-muted\'>'+ $t('step_2') + '</div>' + $t('preview_group_questions')"
                          :before-change="() =>validateStep(2)">
                <div class="col-md-8 offset-md-2">
                    <b-card no-body class="pr-3 pl-3 mb-3">
                        <h3 class="pt-3" style="text-align:center">{{$t('question_group')}}</h3>
                    
                        <div style="height:50vh;overflow-y: scroll">
                            <b-tabs class="nav-tabs-top nav-responsive-xl">
                                <b-tab v-for="language in languages" :title="getLanguage(language)">
                                    <div v-for="(question, index) in coreQuestion">
                                        <QuestionItem :question="question" source="core" :position="index +1" :language="language" class="pr-3 pl-3"></QuestionItem>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </b-card>
                </div>
            </tab-content>
            <tab-content v-if="surveyType == 'grouplocal'" :title="'<div class=\'small text-muted\'>'+ $t('step_3') + '</div>' + $t('question_local') +''">
                <b-card class="mb-3">
                   {{ $t('disclaimer_questioteque')}}
                </b-card>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <b-card no-body class="mb-2 pl-3">
                            <h4 class="pt-3" style="text-align:center">{{ $t('questiotheque')}}</h4>
                        </b-card>
                        <b-card no-body class="mb-2 pl-3 pt-2 pb-2">
                            <QuestionSearch source="COMM" class=""/>
                        </b-card>
                        <div no-body style="height:45vh; overflow-y: scroll;">
                            <div v-dragula="questionData" bag="first-bag">
                                <div v-for="question in questionData" :key="question.id">
                                    <QuestionItem :question="question" source="comm" :languageSlug="$cookie.get('language')">
                                        <b-btn v-on:click="addQuestion(question.id)"
                                               v-b-tooltip.hover title="Ajouter"><i
                                                class="ion ion-md-arrow-forward"></i></b-btn>
                                    </QuestionItem>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <b-card no-body class="mb-2 pl-3">
                            <h4 class="pt-3" style="text-align:center">{{ $t('local_selected_questions')}}</h4>
                        </b-card>
                        <div no-body style="height:50vh; overflow-y: scroll">
                            <div v-for="(question, index) in questionChosen" :key="question.id">
                                <QuestionItem :question="question" source="core" :position="index+1" :languageSlug="$cookie.get('language')">
                                    <b-btn v-on:click="downQuestion(question.id)"
                                           v-b-tooltip.hover title="Descendre"><i
                                            class="ion ion-md-arrow-dropup-circle"></i></b-btn>
                                    <b-btn v-on:click="upQuestion(question.id)"
                                           v-b-tooltip.hover title="Monter"><i
                                            class="ion ion-md-arrow-dropdown-circle"></i></b-btn>
                                    <b-btn v-on:click="removeQuestion(question.id)"
                                           v-b-tooltip.hover title="Supprimer"><i
                                            class="ion ion-md-trash"></i></b-btn>
                                    <label class="switcher switcher-info">
                                        <input type="checkbox" class="switcher-input"
                                               @change="mandatoryQuestion(question.id)" :value="question.is_mandatory" :checked="question.is_mandatory">
                                        <span class="switcher-indicator">
                                              <span class="switcher-yes"><span class="ion ion-md-checkmark"></span></span>
                                              <span class="switcher-no"><span class="ion ion-md-close"></span></span>
                                            </span>
                                        <span class="switcher-label">{{ $t('mandatory') }}</span>
                                    </label>
                                </QuestionItem>
                            </div>
                        </div>
                    </div>
                </div>
            </tab-content>
            <b-btn variant="default" slot="prev">{{ $t('back') }}</b-btn>
            <b-btn variant="default" slot="next">{{ $t('next') }}</b-btn>
            <b-btn v-on:click="addSurvey('INC')" class="ml-3" slot="finish" variant="primary">{{ $t('save')}}</b-btn>
            <b-btn v-on:click="addSurvey('COM')" class="ml-3" slot="finish" variant="primary">{{ $t('create_the_survey') }}</b-btn>
        </form-wizard>
    </div>
</template>
<style src="vue-dragula/styles/dragula.css"></style>
<style src="@/vendor/libs/vuejs-datepicker/vuejs-datepicker.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-form-wizard/vue-form-wizard.scss" lang="scss"></style>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
    import TitleCustom from '../components/title'
    import QuestionItem from '../components/QuestionItem'
    import {
        ADMIN_DELETE_QUESTION_REQUEST,
        ADMIN_GET_QUESTIONS_REQUEST
    } from '../_store/administration/questionnary/actiontypes'
    import {GET_LANGUAGES_REQUEST} from "../_store/translation/actiontypes";
    import {GET_COMPANIES_REQUEST, GET_HIERARCHICAL_COMPANIES_REQUEST} from "../_store/company/actiontypes";
    import {
        ADD_SURVEYS_REQUEST, ADD_SURVEY_REQUEST, GET_SURVEY_REQUEST
    } from '../_store/survey/actiontypes'
    import {mapState} from 'vuex'
    import Vue from 'vue'
    import VueDragula from 'vue-dragula'
    import QuestionSearch from '../components/QuestionSearch'
    import QuestionAdd from '../components/QuestionAdd'
    import Datepicker from 'vuejs-datepicker'
    import moment from 'moment'
    import Breadcumb from "../components/breadcumb";
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard'
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
    import VJstree from 'vue-jstree'

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            if (file === undefined) {
                return resolve(null);
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            }
        });
    }

    Vue.use(VueDragula);

    function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        arr = arr.filter(item => {
            return item !== null && item !== undefined
        })
        return arr; // for testing
    };

    function getChildrens(company, companies) {
        return company.companies.map(children => {
            let selected = false;
            if (companies && companies !== []){
                selected = companies.find(comp => comp.id === children.id);
            }
            
            if (children.companies.length > 0) {
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': selected,
                    'children': getChildrens(children, companies),
                    'opened': false,
                }
            } else {
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': selected,
                    'children': [],
                    'opened': false,
                }
            }

        })
    }

    export default {
        name: 'createSurvey',
        created() {
        },
        components: {
            Breadcumb, QuestionItem, QuestionSearch, QuestionAdd,
            Datepicker, FormWizard, TabContent, WizardStep,
            SweetModal, SweetModalTab, VJstree
        },
        computed: {
            ...mapState({
                questionData: state => state.admin_questionnary.questions,
            }),
            displayGroupQuestion: function () {
                return this.surveyType === 'group' || this.surveyType === 'grouplocal';
            },
            displayLocalQuestion: function () {
                return this.surveyType === 'local' || this.surveyType === 'grouplocal';
            }
        },
        mounted() {
            this.breadcumbData = [
                {text: this.$t('welcome'), href: '/dashboard/' },
                {text: this.$t('surveys_list'), href: '/survey/'},
                {text: this.$t('create_survey'), active: true}
            ]
            this.surveyTypes = [
                {
                    value: 'group',
                    text: this.$t('group_baro')
                },
                {
                    value: 'grouplocal',
                    text: this.$t('group_survey_specificities')
                }
            ];
            this.$store.dispatch(GET_LANGUAGES_REQUEST)
                .then(response => {
                    this.languageData = response.data.languages.map(item => {
                        if (this.$cookie.get('language') === 'fr'){
                            return {
                                "value": item.id,
                                "text": item.name
                            }
                        } else {
                            return {
                                "value": item.id,
                                "text": item.name_en
                            }
                        }
                        
                    })
                });
            if (this.$route.params.id) {
                this.$store.dispatch(GET_SURVEY_REQUEST, this.$route.params.id)
                    .then(response => {
                        this.label = response.data.survey.label;
                        this.description = response.data.survey.description;
                        this.languages = response.data.survey.language.map(language => {
                            return language.id
                        });
                        this.surveyType = response.data.survey.type;
                        this.date = response.data.survey.publication_date;
                        this.dateend = response.data.survey.publication_end;
                        this.questionChosen = response.data.survey.questions.filter(q => q.source !== 'CORE');
                        this.coreQuestion = response.data.survey.questions.filter(q => q.is_core && q.is_core === true);
                        this.type = response.data.survey.type;
                        this.companies = response.data.survey.companies;
                        this.partner = response.data.survey.partner_type
                        this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
                            .then(response => {
                                this.treeData = response.data.hierarchical_companies.map(company => {
                                    let childrens = [];
                                    if (company.companies.length > 0) {
                                        childrens = getChildrens(company, this.companies)
                                    }
                                    let selected = false;
                                    console.log(this.companies);
                                    if (this.companies && this.companies !== []){
                                        selected = this.companies.find(comp => comp.id === company.id);
                                    }
                                    
                                    return {
                                        'show-checkbox': false,
                                        'text': company.name,
                                        'id': company.id,
                                        'children': childrens,
                                        'opened': false,
                                        'selected': selected
                                    }
                                });
                                console.log(this.treeData);
                            });
                    })
            }
            else{
                this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
                    .then(response => {
                        this.treeData = response.data.hierarchical_companies.map(company => {
                            let childrens = [];
                            if (company.companies.length > 0) {
                                childrens = getChildrens(company, this.companies)
                            }
                            let selected = false;
                            return {
                                'show-checkbox': false,
                                'text': company.name,
                                'id': company.id,
                                'children': childrens,
                                'opened': false,
                                'selected': selected
                            }
                        });
                        console.log(this.treeData);
                    });
            }
            
            this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: 'CORE'})
                .then(response => {
                    if (this.coreQuestion.length === 0) {
                        this.coreQuestion = response.data.questions.map(question => {
                            question.is_mandatory = "TRUE";
                            question.is_core = true;
                            return question;
                        });
                    }
                    this.coreQuestionNumber = response.data.questions.length;
                    this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: 'COMM'})
                })
        },
        data() {
            return {
                error: false,
                treeData: [],
                companies: [],
                companiesData: [],
                targets: [],
                additional_provider: false,
                partner: 'directobea',
                email: '',
                surveyBuilder: false,
                surveyParams: true,
                breadcumbData: [],
                groupQuestionDisp: true,
                questionAddKey: 0,
                preData: null,
                tabIndex: 0,
                date: '',
                dateend: '',
                coreQuestion: [],
                languageData: [],
                languages: [],
                questionChosen: [],
                questionOpen: 0,
                label: '',
                description: '',
                coreQuestionNumber: 0,
                showCoreQuestion: false,
                surveyType: 'group',
                surveyTypes: [],
            }
        },
        layout(context) {
            return 'layout'
        },
        methods: {
            getLanguage(language_id) {
                return this.languageData.find(item => {
                    if (item.value === language_id)
                        return item.text
                })
            },
            reloadCustom() {
                this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {
                    source: "CUST"
                });
                this.tabIndex = 1;
            },
            mandatoryQuestion: function (question_id) {
                this.questionChosen = this.questionChosen.map(question => {
                    if (question.id === question_id) {
                        question.is_mandatory = !question.is_mandatory;
                    }
                    return question;
                })
            },
            typeChange(event) {
                if (event === 'local') {
                    this.groupQuestionDisp = false;
                } else {
                    this.groupQuestionDisp = true;
                }
            },
            showCoreQuestions: function (e) {
                this.showCoreQuestion = !this.showCoreQuestion;
            },
            validateStep: function (step) {
                console.log(step);
                if (step === 1) {
                    console.log(this.companies);
                    if (this.languages.length > 0 && this.label && this.surveyType && this.date && this.dateend && this.companies) {
                        this.error = false;
                        return true
                    } else {
                        this.error = "Veuillez remplir l'ensemble des champs de paramètrage de l'enquête";
                        return false
                    }
                }
                return true
            },
            surveyParamBack: function (e) {
                this.surveyParams = true;
                this.surveyBuilder = false;
            },
            addSurvey: function (state) {
                let id = this.$route.params.id || null;
                let questions;
                if (this.surveyType === 'group' || this.surveyType === 'grouplocal')
                    questions = this.coreQuestion.concat(this.questionChosen);
                else {
                    questions = this.questionChosen
                }
                this.$store.dispatch(ADD_SURVEY_REQUEST, {
                    label: this.label,
                    questions: questions,
                    language: this.languages,
                    publication_date: moment(this.date).format('YYYY-MM-DD'),
                    publication_end: moment(this.dateend).format('YYYY-MM-DD'),
                    companies_tree: this.treeData,
                    targets: null,
                    type: this.surveyType,
                    state: state,
                    action: this.$route.params.action,
                    id: id,
                    partner_type: this.partner,
                    partner_email: this.email,
                    additional_provider: this.additional_provider
                })
                    .then(() => {
                        this.$router.push('/survey/')
                    })
                    .catch((error) => {
                        console.log('error is ==');
                        console.log(error);
                    })
            },
            searchQuestion(source) {
                this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {
                    tag_id: this.tag_id,
                    source: source
                })
            },
            addQuestion(question_id) {
                this.questionData.find(question => {
                    if (question_id === question.id) {
                        let find = false
                        for (let index = 0; index < this.questionChosen.length; index++) {
                            if (question_id === this.questionChosen[index].id) {
                                find = true
                            }
                        }
                        if (find === false) {
                            question.is_mandatory = true;
                            this.questionChosen.push(question)
                        }
                    }
                })
            },
            editQuestion(question_id) {
                this.tabIndex = 2;
                this.questionData.find(question => {
                    if (question_id === question.id) {
                        this.preData = {
                            question_id: question.id,
                            label: question.label,
                            label_en: question.label_en,
                            tags: question.tags.map(tag => {
                                return tag.id
                            }),
                            answers: question.answers,
                            type: question.type,
                        }
                        this.questionAddKey += 1;
                    }
                })
            },
            removeQuestion(question_id) {
                this.questionChosen = this.questionChosen.filter(question => {
                    if (question_id !== question.id)
                        return question
                })
            },
            deleteQuestion(question_id) {
                this.$store.dispatch(ADMIN_DELETE_QUESTION_REQUEST, question_id)
                    .then(response => {
                        this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {
                            source: "CUST"
                        })
                    })
            },
            upQuestion(question_id) {
                let position = this.questionChosen.findIndex(question => question !== undefined && question.id === question_id);
                this.questionChosen = array_move(this.questionChosen, position, position + 1)
            },
            downQuestion(question_id) {
                let position = this.questionChosen.findIndex(question => question !== undefined && question.id === question_id);
                if (position !== 0) {
                    this.questionChosen = array_move(this.questionChosen, position, position - 1)
                }
            }
        }
    };
</script>
<style>
    .nav-link.active {
        background: #f5f5f5 !important;
    }
    
    .tab-content {
        background: #f5f5f5 !important;
    }
</style>
